// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"_1FK6VLk-J JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U _2WNDOuoxI"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/checkbox/checkbox.css
 ** module id = 2157
 ** module chunks = 0
 **/